import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ModalService } from './services/modal.service';
import { SnackBarService } from './services/snackbar.service';

import { ReactiveFormsModule } from '@angular/forms';
import { NgxPrintModule } from 'ngx-print';
import { LiatActivationFormComponent } from './components/liat-activation-form/liat-activation-form.component';
import { LiatActivationRouterModule } from './liat-activation.router.module';
import { OneWebComponentsAngularModule } from '@one/angular';
import * as activationComponent from './components';
import { TranslocoRootModule } from '../../transloco-root.module';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgxPrintModule,
    OneWebComponentsAngularModule,
    LiatActivationRouterModule,
    LiatActivationFormComponent,
    activationComponent.allComponents,
  ],
  //exports: [LiatActivationFormComponent],
  providers: [ModalService, SnackBarService],
})
export class LiatActivationModule {}
